import forEach from 'lodash/forEach'

export default function csstyle(comp, part, opts) {
  if ('object' === typeof part) {
    opts = part
    part = undefined
  }

  let names = part ? `${comp}__${part}` : comp

  forEach(opts, (v, k) => {
    if (true === v) names = `${names} --${k}`
    else if (v || v === 0) names = `${names} --${k}:${v}`
  })

  return names
}
